<template>
  <div class="block15">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1" id="cfsb">存放设备</h2>

      <div class="container-content">
        <p>工具箱/文档袋</p>
        <p>工具箱和文档袋都在鞍座下方。如图所示,用橡胶带固定工具箱和文档袋。</p>
        <p class="text_square">
          <router-link to="/block20/anzuo">打开鞍座</router-link>
        </p>
        <div>
          <img src="./img/img1.jpg" alt width="100%" />
          <!-- 内容 -->
        </div>
        <p id="tkj">头盔架</p>
        <p>头盔架位于鞍座下方。</p>
        
        <div>
          <img src="./img/img3.jpg" alt width="100%" />
          <!-- 内容 -->
        </div>
        <p><img src="../img/san.png">仅在驻车时使用头盔架</p>
        <p class="text_square">
          <router-link to="/block20/anzuo">打开鞍座</router-link>
        </p>
        <div class="warningbox">
          <div class="top">
            <span>警告</span>
          </div>
          <div class="line">
            <p>
              将头盔悬挂在头盔挂钩上驾骑时，会干扰您安全操纵摩托车，可能导致事故，造成严重伤亡。
            </p>
            <p>
              仅在停车时使用头盔挂钩。请勿在驾骑时将头盔固定在头盔挂钩上。
            </p>
          </div>
        </div>

        <p>行李挂钩</p>
        <p>行李挂钩在鞍座底部。</p>
        <img src="./img/img2.jpg" width="100%">
        <p><img src="../img/san.png">请不要使用行李挂钩拖拉其他车辆。</p>
        <p class="text_square">
          <router-link to="/block20/anzuo">打开鞍座</router-link>
        </p>
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block14">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block16">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>